import { createRequest } from '@shared/services';

export async function getSearchSuggestion(params: { query: string }) {
    const request = createRequest<GetSearchSuggestionResponse>({
        url: '/search/suggestion',
        method: 'GET',
        withAuthorization: true,
        params,
    });

    return request.execute();
}

export async function getSearchLoveCode(params: { keyword: string }) {
    const request = createRequest<GetSearchLoveCodeResponse>({
        url: '/search/love-code',
        method: 'GET',
        withAuthorization: true,
        params,
    });

    return request.execute();
}
